import {
  Box,
  Text,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import Reveal from "./motion";

export type FAQItem = { question: string; answer: string };

type FAQAccordionProps = {
  id: string;
  eyebrow: string;
  heading: string;
  items: FAQItem[];
  accentColor?: string;
};

const FAQAccordion = ({ id, eyebrow, heading, items, accentColor = "lime.700" }: FAQAccordionProps) => (
  <Box
    as="section"
    id={id}
    py={{ base: 20, md: 28 }}
    maxW="1000px"
    mx="auto"
    px={{ base: 5, md: 8 }}
  >
    <Reveal textAlign="center" mb={12}>
      <Text color={accentColor} fontWeight="bold" fontSize="sm" letterSpacing="wide" mb={3}>
        {eyebrow}
      </Text>
      <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }}>
        {heading}
      </Heading>
    </Reveal>

    <Reveal delay={0.1}>
      <Accordion allowToggle display="flex" flexDirection="column" gap={4}>
        {items.map((item) => (
          <AccordionItem
            key={item.question}
            border="1px solid"
            borderColor="chalk.400"
            borderRadius="lg"
            bg="chalk.50"
            overflow="hidden"
          >
            <AccordionButton
              _expanded={{ color: accentColor, bg: "chalk.200" }}
              _hover={{ bg: "chalk.200" }}
              py={5}
              px={6}
            >
              <Box flex="1" textAlign="left" fontSize="md" fontWeight="medium">
                {item.question}
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb={6} px={6} fontSize="sm" color="slate.700" lineHeight="1.8">
              {item.answer}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </Box>
);

export default FAQAccordion;
